import { render, staticRenderFns } from "./TheHomeGallery.vue?vue&type=template&id=a67a5008&scoped=true"
import script from "./TheHomeGallery.vue?vue&type=script&lang=js"
export * from "./TheHomeGallery.vue?vue&type=script&lang=js"
import style0 from "./TheHomeGallery.vue?vue&type=style&index=0&id=a67a5008&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a67a5008",
  null
  
)

export default component.exports